<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Rl23h/images/Cover.jpg?1684245187614" alt="This image is the cover for the book Alice Ever After #2, Alice Ever After"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alice Ever After #2, Alice Ever After
      </h1>
      <p class="bookDescription body article font2">
        <p>Alice might have opened the door to Wonderland, but the asylum is its own realm of darkness and danger. Mistress Hulda resembles an all-too-familiar queen, and Dr. Madsen is eager to try an experimental treatment, probing into a past that Alice wants to escape… and one her father will do anything to keep hidden. Will an inmate with an intriguing smile prove to be a much needed friend, or will Alice’s fate be the same as the inmates in the common room, the ones with the vacant eyes?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Panosian, Giorgio Spalletta
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c18e670